import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SidebarComponent from '../common/sidebar-component';
import ContributorResultsContext from './context';
import SidebarComponentHeader from '../common/sidebar/sidebar-component-header';
import useGetColleaguesOf from '../../../services/contributors/colleagues-service';
import NanoProfile from '../common/nano-profile';

const ColleaguesContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding-top: 20px;
`;

export default function Colleagues({ profile }) {
  const { dispatch } = React.useContext(ContributorResultsContext);
  const [{ data }, executeQuery] = useGetColleaguesOf(profile.id, 3);

  React.useEffect(() => {
    executeQuery();
  }, [executeQuery]);

  React.useEffect(() => {
    if (_.get(data, 'colleagues.length')) {
      dispatch({ type: 'setColleagues', payload: data.colleagues });
    }
  }, [data, dispatch]);

  if (!_.get(data, 'colleagues.length')) {
    return null;
  }

  return (
    <SidebarComponent>
      <SidebarComponentHeader
        title="other contributors from"
        query={profile.organisation}
      />
      <ColleaguesContainer>
        {data.colleagues.map(p => (
          <NanoProfile key={`colleague-${p.id}`} profile={p} dark small />
        ))}
      </ColleaguesContainer>
    </SidebarComponent>
  );
}

Colleagues.propTypes = {
  profile: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    organisation: PropTypes.string,
  }).isRequired,
};
